import type { MeasurementMapObject } from "../types";
import {
    type MeasurementPoseMode,
    type MeasurementRaw,
    resolveMeasurementPose,
} from "./measurementPose";

export type { MeasurementPoseMode, MeasurementRaw } from "./measurementPose";

export function parseMeasurements(
    measurements: MeasurementRaw[] | null | undefined,
    poseMode: MeasurementPoseMode = "telemetry-optimized",
): MeasurementMapObject[] {
    if (!Array.isArray(measurements)) return [];

    return measurements.flatMap((measurement): MeasurementMapObject[] => {
        const resolvedPose = resolveMeasurementPose(measurement, poseMode);
        if (!resolvedPose) return [];

        const { position, orientation } = resolvedPose.pose;

        return [
            {
                id: measurement.id,
                type: "measurement",
                x: position.x,
                y: position.y,
                z: position.z,
                yaw: orientation.y * (180 / Math.PI),
                deleted: measurement.deletedAt !== undefined,
                interactive: true,
            },
        ];
    });
}
